module.exports = __webpack_public_path__ + "static/media/work_in_progress.f23a9892.png";